import Vue from "vue";
import { WebCam } from "vue-cam-vision";

Vue.component(WebCam.name, WebCam);
